import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']
  static classes = ['active']

  over(event) {
    event.preventDefault()
    this.element.classList.add(...this.activeClasses)
  }

  leave(event) {
    if (this.element.contains(event.relatedTarget)) return

    this.element.classList.remove(...this.activeClasses)
  }

  drop(event) {
    event.preventDefault()
    this.element.classList.remove(...this.activeClasses)

    const file = event.dataTransfer.files[0]
    if (!file) return

    const data = new DataTransfer()
    data.items.add(file)
    this.inputTarget.files = data.files
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }
}
